module.exports = __webpack_public_path__ + "static/media/luck-miner.7038a04f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GameIcon/luck-miner.png
// module id = 1360
// module chunks = 1